var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 3C0.833008 2.72386 1.05687 2.5 1.33301 2.5H14.6663C14.9425 2.5 15.1663 2.72386 15.1663 3V13C15.1663 13.2761 14.9425 13.5 14.6663 13.5H1.33301C1.05687 13.5 0.833008 13.2761 0.833008 13V3ZM1.83301 3.5V12.5H14.1663V3.5H1.83301Z",
    fill: "#B4E08E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.933037 2.70003C1.09872 2.47912 1.41212 2.43434 1.63304 2.60003L7.9997 7.37503L14.3664 2.60003C14.5873 2.43434 14.9007 2.47912 15.0664 2.70003C15.2321 2.92094 15.1873 3.23434 14.9664 3.40003L8.2997 8.40003C8.12193 8.53336 7.87748 8.53336 7.6997 8.40003L1.03304 3.40003C0.812123 3.23434 0.767352 2.92094 0.933037 2.70003Z",
    fill: "#B4E08E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833008 3C0.833008 2.72386 1.05687 2.5 1.33301 2.5H7.99967C8.27582 2.5 8.49967 2.72386 8.49967 3C8.49967 3.27614 8.27582 3.5 7.99967 3.5H1.83301V8C1.83301 8.27614 1.60915 8.5 1.33301 8.5C1.05687 8.5 0.833008 8.27614 0.833008 8V3Z",
    fill: "#B4E08E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3C7.5 2.72386 7.72386 2.5 8 2.5H14.6667C14.9428 2.5 15.1667 2.72386 15.1667 3V8C15.1667 8.27614 14.9428 8.5 14.6667 8.5C14.3905 8.5 14.1667 8.27614 14.1667 8V3.5H8C7.72386 3.5 7.5 3.27614 7.5 3Z",
    fill: "#B4E08E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.84a21d84633d6e713ee97ca0e51b9c48.svg";
export { ForwardRef as ReactComponent };